var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.912,
    height: 25.912,
    viewBox: "0 0 25.912 25.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Medal_icon",
    "data-name": "Medal icon",
    d: "M4.324-5.633l-3.5-5.831A1.616,1.616,0,0,0-.564-12.25H-6.189a.81.81,0,0,0-.664,1.274l5.631,8.045A10.474,10.474,0,0,1,4.324-5.633ZM18.1-12.25H12.475a1.619,1.619,0,0,0-1.389.786l-3.5,5.831a10.477,10.477,0,0,1,5.545,2.7l5.631-8.044A.81.81,0,0,0,18.1-12.25ZM5.956-4.153a8.907,8.907,0,1,0,8.907,8.907A8.907,8.907,0,0,0,5.956-4.153Zm4.682,7.959L8.719,5.677,9.173,8.32a.581.581,0,0,1-.843.612L5.956,7.684,3.582,8.931A.581.581,0,0,1,2.74,8.32l.454-2.643L1.274,3.806A.581.581,0,0,1,1.6,2.815l2.653-.387L5.435.023A.572.572,0,0,1,5.955-.3a.577.577,0,0,1,.523.323l1.186,2.4,2.653.387A.581.581,0,0,1,10.638,3.806Z",
    transform: "translate(7 12.25)",
    fill: "#073045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBlack);
export default __webpack_public_path__ + "static/media/medal_black.b12d493febdf52f3c8969d07df90c5f0.svg";
export { ForwardRef as ReactComponent };